import React, { memo, useEffect } from 'react';
import isEqual from 'lodash/isEqual';
import Address from 'app/components/common/Address';
import InputText from 'app/components/common/InputText';
import classNames from 'classnames/bind';
import useEnlog from 'app/hook/common/useEnlog';
import styles from './AddressGroup.module.scss';

const cx = classNames.bind(styles);

const AddressGroup = (props) => {
	const { address, addressList, currentAddress, isExist, onChange, onSearch, onSubmit } = props;

	const { enloggingJsonData } = useEnlog();

	useEffect(() => {
		const dataTalkViewSingle = {
			eventnamegroup: '주소검색',
		};

		enloggingJsonData({
			dataTalkViewSingle,
		});
	}, [enloggingJsonData]);

	let resultAddress = null;
	let num = 0;

	if (isExist.none) {
		num = 0;
		const msg = '검색 결과가 없습니다. \n지역명을 다시 입력해 주세요.';
		resultAddress = <li className={cx('li_none')}>{msg}</li>;
	} else if (isExist.max) {
		num = '99+';
		const msg = '검색결과가 너무 많습니다. \n권장사항 검색 방법을 통해 다시 검색해 주세요.';
		resultAddress = <li className={cx('li_none')}>{msg}</li>;
	} else {
		resultAddress = addressList.map((item) => (
			<Address
				key={item.buildingCd}
				address={item.address}
				landAddress={item.landAddress}
				postCd={item.postCd}
				onClick={onSubmit}
				buildingCd={item.buildingCd}
			/>
		));
		num = resultAddress.length;
	}

	return (
		<div className={cx('address')}>
			<div className={cx('area_search')}>
				<InputText
					label="주소찾기"
					type="text"
					id="address"
					name="address"
					value={address}
					placeholder="도로명+건물번호, 건물명, 지번"
					onChange={onChange}
					onClick={onSearch}
					useLabel
					useBtn
					btnName="검색"
					inputDesignClass={cx('input_address')}
					style={{ padding: '0 20px' }}
					maxLength={40}
					data-enlog-dt-eventnamegroup="주소검색"
				/>
			</div>
			{!currentAddress && (
				<div className={cx('area_notice')}>
					<p className={cx('tit_notice')}>정확한 검색을 위하여 다음 권장사항을 확인하세요.</p>
					<ul className={cx('list_notice')}>
						<li>
							도로명으로 조회 <span className={cx('grey')}>: (ex. 종로구 사직로 161)</span>
						</li>
						<li>
							지번으로 조회 <span className={cx('grey')}>: (ex. 종로구 관훈동 198-1)</span>
						</li>
						<li>
							건물명으로 조회 <span className={cx('grey')}>: (ex. 종로구 홍익빌딩)</span>
						</li>
						<li>
							<span className={cx('grey')}>*건물명은 각 자치단체에서 등록한 경우 조회가 가능합니다.</span>
						</li>
					</ul>
				</div>
			)}
			{currentAddress && (
				<div className={cx('area_list')}>
					<div className={cx('area_search_text')}>
						<span className={cx('total')}>{`총 ${num}건`}</span>
					</div>
					<ul
						id="addressList"
						className={cx('list_address')}
					>
						{resultAddress}
					</ul>
				</div>
			)}
		</div>
	);
};

export default memo(AddressGroup, isEqual);
